var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2916 10.0011C17.2916 10.3461 17.0116 10.6261 16.6666 10.6261H4.84242L7.10906 12.8928C7.35323 13.1369 7.35323 13.5328 7.10906 13.777C6.9874 13.8986 6.82737 13.9603 6.66737 13.9603C6.50737 13.9603 6.34735 13.8995 6.22568 13.777L2.89235 10.4436C2.83485 10.3861 2.78913 10.317 2.75746 10.2404C2.69413 10.0879 2.69413 9.91538 2.75746 9.76288C2.78913 9.68621 2.83485 9.61693 2.89235 9.55943L6.22568 6.22609C6.46985 5.98193 6.86571 5.98193 7.10988 6.22609C7.35404 6.47026 7.35404 6.86612 7.10988 7.11029L4.84324 9.37693H16.6666C17.0116 9.3761 17.2916 9.65612 17.2916 10.0011Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7b27fdfe8da25e320d3b4149cdfe50d7.svg";
export { ForwardRef as ReactComponent };